import { Vue, Component, Watch } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';
// @ts-ignore
import Layout from '@component/layout/index.vue';
import { Message } from '@ks/kwai-ui';
import sso from '@utils/sso';
import generalSSO from '../../../../utils/generalSSO';
import { services } from '@utils/service';
// import kslog from '@utils/kslog';
import Ktrace from '@utils/ktrace'; // ktrace 在 weblog 之前引入
import { setCookie } from '@utils/cookie';
import { getUserId, throttle, valid } from '@utils/utils';
import { merchantStatus } from '@utils/permission/config.ts';
import { getUrlParam } from '@utils/url';

import Axios from 'axios';
import {
    Carousels,
    PHONE_LENGTH,
    CAPCHA_LENGTH,
    TIMER,
    INTERVAL,
    COUNTRY_CODE,
    PHONE_ERRMSG,
    CAPCHA_ERRMSG,
    isNumber,
} from './config';
import refreshImgSrc from '@asset/images/login/refresh@2x.png';
import phoneImgSrc from '@asset/images/login/phone@2x.png';
import logoImgSrc from '@asset/images/logo/logo@2x.png';
import loginLogoImgSrc from '@asset/images/login/home_logo2.png';
import loginBgImgSrc from '@asset/images/login_bg.png';
import step1ImgSrc from '@asset/images/login/step1@2x.png';
import step2ImgSrc from '@asset/images/login/step2@2x.png';
import step3ImgSrc from '@asset/images/login/step3@2x.png';
import step4ImgSrc from '@asset/images/login/step4@2x.png';
import step5ImgSrc from '@asset/images/login/step5@2x.png';
import empolyer from '@asset/images/login/empolyer.png';
import empolyee from '@asset/images/login/empolyee.png';
import roleList from './component/roleList.vue';
import { result } from 'lodash';
import { clickLog } from '../../../../utils/ksWeblog';
import { queryServiceStaffUserList } from '@services/merchant/user-role-manage-controller';

enum EServePubAccountType {
    /** @name  主账号登录（店主/我要开店） */
    MainAccount = 1,
    /** @name  子账号登录（我是员工） */
    SubAccount,
}

enum EMobileType {
    // 主账号获取短信验证码的type值
    MainAccountMobileType = 53,
    // 服务商子账号获取短信验证码的type值
    SubAccountMobileType = 20171,
}

@Component({
    components: {
        Layout,
        roleList,
    },
})
export default class Login extends Vue {
    @Getter('loginConfig') loginConfig: any;
    @Getter('userInfo') userInfoData: any;
    @Action('setUserInfo') setUserInfo: any;
    @Getter('userInfo') userInfo: any;
    @Getter('settleSource') settleSource: string | undefined;
    @Getter('bdOperateCode') bdOperateCode: string | undefined;
    EServePubAccountType = EServePubAccountType;
    carousels: object[] = Carousels;
    activeName: string = 'first';
    phoneImgSrc: string = phoneImgSrc;
    refreshImgSrc: string = refreshImgSrc;
    qrImgSrc: string = '';
    loginLogoImgSrc: string = loginLogoImgSrc;
    loginBgImgSrc: string = loginBgImgSrc;
    logoImgSrc: string = logoImgSrc;
    empolyer = empolyer;
    empolyee = empolyee;
    isQRExpired: boolean = false;
    showRoleList: boolean = false;
    isLoading: Boolean = false;
    singedMerchants: any = [];
    keyword: string = '';
    selectIndex: any = null;
    pageSize: number = 6;
    pageNum: number = 1;
    noMore: Boolean = false;
    scrollLoad: Function = throttle(this.scrollLoadMore, 50);
    totalNum: number = 0;
    form = {
        phone: '',
        phonePlaceholder: '请输入手机号',
        phoneLength: PHONE_LENGTH,
        phoneErrorMsg: '',
        capcha: '',
        capchaPlaceholder: `请输入${CAPCHA_LENGTH}位验证码`,
        timer: 0,
        capchaLength: CAPCHA_LENGTH,
        capchaErrorMsg: '',
        focusStatus: false,
    };
    dialogData: object[] = [
        {
            title: '一、打开快手APP, 找到左上角“ ” 唤起侧边栏',
            imgSrc: step1ImgSrc,
        },
        {
            title: '二、找到侧边栏的“更多”',
            imgSrc: step2ImgSrc,
        },
        {
            title: '三、找到“本地生活”',
            imgSrc: step3ImgSrc,
        },
        {
            title: '四、点击右上角“开店',
            imgSrc: step4ImgSrc,
            style: { height: '542px' },
        },
        {
            title: '五、选择具体行业、完成店铺入驻',
            imgSrc: step5ImgSrc,
            style: { height: '542px' },
        },
    ];
    showDialog: boolean = false;
    multiUserDialog: object = {
        open: false,
        userInfos: [],
        multiUserToken: '',
    };
    authToken: string = '';
    sid: string = '';

    accountTypeSelectShow = true;
    loginShow: boolean = false;
    // 默认是主账号
    accountType = EServePubAccountType.MainAccount;

    multiUserToken = '';
    isFromSmeargle = false;
    // 下载商家App
    mobileDownLoadUrl = {
        staging: 'https://v1.adkwai.com/kos/nlav12679/lfe-media-source/bussinessApp/stagingLoad.png',
        prt: 'https://v1.adkwai.com/kos/nlav12679/lfe-media-source/bussinessApp/prtLoad.png',
        prod: 'https://v1.adkwai.com/kos/nlav12679/lfe-media-source/bussinessApp/onlineLoad.png',
    };
    env = process.env.net_env || 'prod';

    public get expiredClass(): string {
        return this.isQRExpired ? 'qr-expired' : '';
    }

    public get phoneErrorClass(): string {
        return this.form.phoneErrorMsg ? 'login-item--phone__error' : '';
    }

    public get capchaErrorClass(): string {
        return this.form.capchaErrorMsg ? 'login-item--capcha__error' : '';
    }

    public get capchaFocusClass(): string {
        return this.form.focusStatus ? 'login-item--capcha__focus' : '';
    }

    get bdParams(): string {
        return `&settleSource=${this.settleSource}&bdOperateCode=${this.bdOperateCode}`;
    }
    created() {
        this.activeName = 'first';
        // 针对服务商系统跳转过来带from参数的登录
        const from = getUrlParam('from');
        // 如果是服务商
        if (from === 'smeargle') {
            this.activeName = 'second';
            this.isFromSmeargle = true;
            this.accountTypeSelect(EServePubAccountType.SubAccount);
        } else {
            // 如果是非服务商
            this.getAccountListJudgeLoginStatus();
        }
        this.timerHandler = null;
        // eslint-disable-next-line no-undef
        if (!EASY_ENV_IS_NODE && this.activeName === 'first') {
            this.qrLogin();
        }
        this.$weblog.sendFmp();
    }

    mounted() {
        this.$weblog.updateCurrentUrlPackage('LOCALLIFE_WEB_MERCHANT_CENTER_LOG_IN');
        // 商家中心登陆页面埋点
        this.$weblog.pageShowLog({
            page: 'LOCALLIFE_WEB_MERCHANT_CENTER_LOG_IN',
        });
        // setTimeout(() => {
        //     this.activeName = 'first';
        // }, INTERVAL);
    }
    // login页前置登录状态校验，代替node控制器中的写法
    async getAccountListJudgeLoginStatus() {
        const loginAxios = Axios.create();
        try {
            const res = await loginAxios.get(services.getAccountList);
            const userInfo = res?.data?.data || {};
            // 判断当前商家认领状态，是否为新用户或者认领中
            if (userInfo.relMerchantStatus === merchantStatus.no) {
                window.location.href = '/league/admin/bellossom/settle/entry' + location.search + this.bdParams;
                return;
            }
            if (userInfo.relMerchantStatus === merchantStatus.pending) {
                // 单店
                if (userInfo.relMerchantType === 5) {
                    window.location.href = '/league/admin/settle' + location.search;
                } else if (userInfo.relMerchantType === 1) {
                    window.location.href = '/league/admin/bellossom/settle/single' + location.search + this.bdParams;
                } else {
                    window.location.href = '/league/admin/bellossom/settle/multi' + location.search + this.bdParams;
                }
                return;
            }
            const userOrgVOS = userInfo.userOrgVOS || [];
            if (userOrgVOS.length === 1) {
                this.goToHome();
            }
        } catch (error) {
            console.log(error);
        }
    }

    accountTypeSelect(type: EServePubAccountType) {
        // 埋点上报
        this.$weblog.clickLog('IDENTITY_SELECTION_BUTTON', { button_type: type }, {});
        // 如果主账号和子账号tab切换清空电话号码和验证码
        if (this.accountType !== type) {
            this.accountType = type;
            this.form.phone = '';
            this.form.capcha = '';
        }
        if (!EASY_ENV_IS_NODE && this.activeName === 'first') {
            this.qrLogin();
        }
        this.accountTypeSelectShow = false;
        this.loginShow = true;
    }
    closeLogin() {
        this.loginShow = false;
        this.accountTypeSelectShow = true;
    }

    async qrLogin() {
        try {
            const { getQRLoginInfo, getUserLoginInfo, scanQRLoginResult, cancelQrLogin } = sso;
            const { qrLoginSignature, qrLoginToken, imageData } = await getQRLoginInfo();
            this.qrImgSrc = `data:image/png;base64,${imageData}`;
            this.isQRExpired = false;

            // 等待用户扫码，用户扫码完成后可以拿到用户的基础信息
            const user = await getUserLoginInfo({
                qrLoginSignature,
                qrLoginToken,
            });

            // 等待用户在主App点击确认，点击确认后拿到authToken用于后端换取登录凭证
            const { authToken, sid, callback } = await scanQRLoginResult({
                qrLoginSignature,
                qrLoginToken,
            });
            // 用于取消二维码登录流程(防止长连接占用)
            this.authToken = authToken;
            this.sid = sid;
            cancelQrLogin();
            await this.businessLogin({
                authToken,
                sid,
            });
        } catch (e) {
            const data = {
                type: 'login',
                status: 'error',
                msg: '扫码登录出错',
                url: '',
                code: e.result,
            };
            // kslog.sendCountTag(data);
            switch (e.result) {
                case 707:
                    this.isQRExpired = true;
                    break;
                default:
                    // this.isQRExpired = true;
                    break;
            }
        }
    }

    async businessLogin({ authToken, sid }) {
        // localStorage.removeItem('shopId');
        const loginAxios = Axios.create();
        await loginAxios.get(services.login, {
            // 业务登录
            params: {
                authToken,
                sid,
            },
        });

        const res = await loginAxios.get(services.getAccountList);
        const userInfo = res?.data?.data || {};
        if (!userInfo.relMerchantStatus) {
            Message({
                message: '获取商家信息错误，请重试',
                type: 'error',
            });
            return;
        }
        // 判断当前商家认领状态，是否为新用户或者认领中
        if (userInfo.relMerchantStatus === merchantStatus.no) {
            window.location.href = '/league/admin/bellossom/settle/entry' + location.search + this.bdParams;
            return;
        }
        if (userInfo.relMerchantStatus === merchantStatus.pending) {
            // 单店
            if (userInfo.relMerchantType === 5) {
                window.location.href = '/league/admin/settle' + location.search;
            } else if (userInfo.relMerchantType === 1) {
                window.location.href = '/league/admin/bellossom/settle/single' + location.search + this.bdParams;
            } else {
                window.location.href = '/league/admin/bellossom/settle/multi' + location.search + this.bdParams;
            }
            return;
        }
        const userOrgVOS = userInfo.userOrgVOS || [];
        if (userOrgVOS.length === 1) {
            const merchantInfo = userOrgVOS?.[0];
            // setCookie('locallifeSessionCode', merchantInfo.locallifeSessionCode);
            this.setUserInfo({
                ...this.userInfoData,
                ...merchantInfo,
            });
            this.goToHome();
        }
        // if (userOrgVOS.length > 1) {
        //     // 对应多个商家，去选对应商家
        //     this.showRoleList = true;
        // }
    }

    // 服务商子账号业务登录
    async subAccountBusinessLogin(arg) {
        // localStorage.removeItem('shopId');
        const loginAxios = Axios.create();
        await loginAxios.get(services.login, {
            // 业务登录
            params: {
                authToken: arg.authToken,
                sid: arg.sid,
            },
        });
        const res = await loginAxios.get(services.getAccountList);
        const userInfo = res?.data?.data || {};
        if (!userInfo.relMerchantStatus) {
            Message({
                message: '获取商家信息错误，请重试',
                type: 'error',
            });
            return;
        }
        // 服务商子账号不存在为新用户或者认领中,一定是认领成功的
        const userOrgVOS = userInfo.userOrgVOS || [];
        if (userOrgVOS.length === 1) {
            const merchantInfo = userOrgVOS[0];
            // setCookie('locallifeSessionCode', merchantInfo.locallifeSessionCode);
            this.setUserInfo({
                ...this.userInfoData,
                ...merchantInfo,
                userType: userInfo.userType,
            });
            this.goToHome();
        }
    }

    goToHome() {
        // 开放平台授权登录
        // const redirect_url = getUrlParam('redirect_url');
        // if (redirect_url) {
        //     jumpTo(redirect_url);
        //     return;
        // }
        // const { query } = this.$route;
        // const redirect = query.redirect;
        const userId = getUserId(document.cookie);
        const path = '/league';
        Ktrace.setGlobalData({ userId });
        const redirect = getUrlParam('redirectUrl');
        window.location.href = redirect ? decodeURIComponent(redirect) : path;
        // window.location.href = path;
    }

    chooseAccount(params) {
        const { userInfos, multiUserToken } = params;
        this.multiUserDialog = {
            open: true,
            userInfos,
            multiUserToken,
        };
    }

    hideAccountList() {
        this.showRoleList = false;
        this.loginShow = true;
        this.accountTypeSelectShow = false;
    }

    startTimer() {
        this.form.timer = TIMER;
        this.timerHandler = setInterval(() => {
            const timer = this.form.timer - 1;
            this.form.timer = timer;
            if (!timer) {
                clearInterval(this.timerHandler);
            }
        }, INTERVAL);
    }

    stopTimer() {
        this.form.timer = 0;
        this.timerHandler && clearInterval(this.timerHandler);
    }

    clearPhoneErrMsg() {
        this.form.phoneErrorMsg = '';
    }

    clearCapcha() {
        this.form.capcha = '';
    }

    clearSmSErrMsg() {
        this.form.capchaErrorMsg = '';
    }

    checkPhone() {
        let bool = false;
        if (!isNumber(this.form.phone) || this.form.phone.length !== this.form.phoneLength) {
            this.form.phoneErrorMsg = PHONE_ERRMSG;
        } else {
            bool = true;
        }
        return bool;
    }

    checkCapcha() {
        let bool = false;
        if (!isNumber(this.form.capcha) || this.form.capcha.length !== this.form.capchaLength) {
            this.form.capchaErrorMsg = CAPCHA_ERRMSG;
        } else {
            bool = true;
        }
        return bool;
    }

    handleTabClick() {
        // eslint-disable-next-line no-undef
        if (!EASY_ENV_IS_NODE && this.activeName === 'first') {
            this.qrLogin();
        }
    }

    handleRefresh() {
        this.qrLogin();
    }

    async handleCapcha() {
        if (!this.checkPhone()) {
            return;
        }
        this.clearCapcha();
        this.clearSmSErrMsg();
        this.startTimer();
        // 通过判断主子账号来对应主子账号不同的请求接口
        const requestMobileCode =
            this.accountType === EServePubAccountType.MainAccount ? sso.requestMobileCode : generalSSO.requestSmsCode;
        // 通过判断主子账号来对应主子账号的请求type
        const mobileType =
            this.accountType === EServePubAccountType.MainAccount
                ? EMobileType.MainAccountMobileType
                : EMobileType.SubAccountMobileType;
        try {
            await requestMobileCode({
                countryCode: COUNTRY_CODE,
                phone: this.form.phone,
                type: mobileType,
            });
        } catch (e) {
            const { result, error_msg } = e;
            this.stopTimer();
            Message({
                message: error_msg.replace('[${0}]', result),
                type: 'error',
            });
        }
    }

    async handleSubmit() {
        if (!this.checkPhone() && !this.checkCapcha()) {
            return;
        }
        // 如果是主账号手机号和二维码登录走原来的主账号登录流程
        if (this.accountType === EServePubAccountType.MainAccount) {
            this.mainAccountSmsCodeLogin();
        } else {
            // 走子账号登录
            this.subAccountSmsCodeLogin();
        }
    }

    // 主账号手机号验证码登录
    async mainAccountSmsCodeLogin() {
        try {
            const result = await sso.login({
                countryCode: COUNTRY_CODE,
                phone: this.form.phone,
                smsCode: this.form.capcha,
                createId: true,
            });
            this.authToken = result.authToken;
            this.sid = result.sid;
            this.businessLogin({
                authToken: result.authToken,
                sid: result.sid,
            });
        } catch (e) {
            const { result, error_msg, userInfos, multiUserToken } = e;
            const data = {
                type: 'login',
                status: 'error',
                msg: error_msg,
                url: '',
                code: result,
            };
            // kslog.sendCountTag(data);
            switch (result) {
                case 100110031:
                    this.chooseAccount({ userInfos, multiUserToken });
                    break;
                case 100110011:
                    this.form.phoneErrorMsg = error_msg;
                    this.stopTimer();
                    break;
                case 100110007:
                    this.form.capchaErrorMsg = error_msg;
                    break;
                default:
                    Message({
                        message: error_msg,
                        type: 'error',
                    });
            }
        }
    }

    // 子账号手机号验证码登录
    async subAccountSmsCodeLogin() {
        try {
            const result = await generalSSO.smsCodeLogin({
                countryCode: COUNTRY_CODE,
                phone: this.form.phone,
                smsCode: this.form.capcha,
                createId: true,
            });
            // 如果只有一个子账号返回
            if (result.authToken) {
                this.authToken = result.authToken;
                // this.sid = result.sid;
                this.subAccountBusinessLogin({
                    authToken: result.authToken,
                    sid: result.sid,
                });
            } else {
                // 如果是多账号，打开多账号选择的页面，去商家后端接口拿取多账号分页信息供选择
                this.loginShow = true;
                this.showRoleList = true;
                // 多个子账号登录的token
                this.multiUserToken = result['locallife.merchant.api.mt'];
                // 调用登录账号角色
                this.searchRoleList();
                this.$nextTick(() => {
                    const scrollContent = this.$refs['role-table_content'];
                    scrollContent?.addEventListener('scroll', this.scrollLoad, true);
                });
            }
        } catch (e) {
            const { result, error_msg, userInfos, multiUserToken } = e;
            const data = {
                type: 'login',
                status: 'error',
                msg: error_msg,
                url: '',
                code: result,
            };
            if (result === 100110225) {
                Message({
                    message: '当前代运营登录账号已失效，请检查代运营签约手机号是否正确或代运营服务时间是否到期',
                    type: 'error',
                });
            } else {
                // kslog.sendCountTag(data);
                Message({
                    message: error_msg,
                    type: 'error',
                });
            }
        }
    }
    searchRole() {
        this.pageNum = 1;
        this.searchRoleList();
    }
    async searchRoleList(pageSize = 6, pageNum = 1) {
        const { keyword = '' } = this;
        try {
            const params = {
                pageNo: pageNum,
                pageSize,
                keyword,
                phone: this.form.phone,
                token: this.multiUserToken,
            };
            const { data } = await queryServiceStaffUserList(params);
            const { total, serviceStaffUserVOList } = data;
            this.totalNum = total;
            this.singedMerchants = serviceStaffUserVOList;
        } catch (error) {
            // 过期时候的页面处理,弹出错误信息，回到登录页
            this.$message({
                message: error.message,
                type: 'error',
            });
            this.hideAccountList();
        } finally {
            this.isLoading = false;
            if (!this.noMore) {
                setTimeout(() => {
                    const scrollContent = this.$refs['role-table_content'];
                    scrollContent?.addEventListener('scroll', this.scrollLoad, true);
                }, 500);
            }
        }
    }
    selectRole(index) {
        this.singedMerchants = this.singedMerchants.map((item, i) => {
            if (index === i) {
                item.selected = true;
                this.selectIndex = i + 1;
            } else {
                item.selected = false;
            }
            return item;
        });
    }

    submit(index) {
        this.singedMerchants = this.singedMerchants.map((item, i) => {
            if (index === i) {
                item.selected = true;
                this.selectIndex = i + 1;
            } else {
                item.selected = false;
            }
            return item;
        });
        if (!this.selectIndex) {
            this.$message({
                message: '请选择商家身份',
                type: 'error',
            });
        } else {
            const user = this.singedMerchants[this.selectIndex - 1] || {};
            this.chooseUserSubmit(user);
            // const merchantInfo = this.singedMerchants[this.selectIndex - 1] || {};
            // setCookie('locallifeSessionCode', merchantInfo.locallifeSessionCode);
            // this.setUserInfo({
            //     ...this.userInfo,
            //     ...merchantInfo,
            // });
            // this.$emit('goToHome');
        }
    }
    async chooseUserSubmit(user) {
        this.isLoading = true;
        const { chooseUser } = generalSSO;
        try {
            const result = await chooseUser({
                userId: user.ksUserId,
                multiUserToken: this.multiUserToken,
                phone: this.form.phone,
            });
            const authToken = result['locallife.merchant.api.at'];
            const sid = 'locallife.merchant.api';
            this.subAccountBusinessLogin({
                authToken: authToken,
                sid: sid,
            });
        } catch (error) {
            // 账号异常情况下的处理
            this.$message({
                message: error.error_msg,
                type: 'error',
            });
            this.hideAccountList();
        }
        this.isLoading = false;
    }

    scrollLoadMore() {
        const scrollContent = this.$refs['role-table_content'];
        const scrollCell = this.$refs['role-table_cell'];
        const currentScrollTop = scrollContent.scrollTop;
        const currentOffsetHeight = scrollCell.offsetHeight;
        const currentClientHeight = scrollContent.clientHeight;
        if (currentScrollTop + currentClientHeight >= currentOffsetHeight - 10) {
            if (!this.isLoading && !this.noMore) {
                this.isLoading = true;
                this.pageNum += 1;
                this.searchRoleList(this.pageSize, this.pageNum);
                scrollContent?.removeEventListener('scroll', this.scrollLoad, true);
            }
        }
    }
    handlePageClick(pageNum) {
        this.searchRoleList(this.pageSize, pageNum);
    }
    handlerPhoneFocus() {
        this.clearPhoneErrMsg();
    }

    handlerCapchaFocus() {
        this.clearSmSErrMsg();
        this.form.focusStatus = true;
    }

    handlerCapchaBlur() {
        this.form.focusStatus = false;
    }

    async handlerUserClick(user) {
        const { chooseUser } = sso;
        const result = await chooseUser({
            userId: user.userId,
            multiUserToken: this.multiUserDialog.multiUserToken,
            phone: this.form.phone,
            countryCode: COUNTRY_CODE,
        });
        this.authToken = result['kuaishou.lbs.merchant.at'];
        this.sid = this.loginConfig.sid;
        this.businessLogin({
            authToken: result['kuaishou.lbs.merchant.at'],
            sid: this.loginConfig.sid,
        });
        this.multiUserDialog.open = false;
    }

    handlerPhoneChange(value) {
        if (!isNumber(value)) {
            this.form.phone = '';
        }
        if (value.length > this.form.phoneLength) {
            this.form.phone = this.form.phone.substr(0, this.form.phoneLength);
        }
    }

    handlerCapchaChange(value) {
        if (!isNumber(value)) {
            this.form.capcha = '';
        }
        if (value.length > this.form.capchaLength) {
            this.form.capcha = this.form.capcha.substr(0, this.form.capchaLength);
        }
    }

    @Watch('loginShow')
    @Watch('activeName')
    handlerLoginShowChange(val: boolean | 'first' | 'second') {
        if (val === 'first' || (val === true && this.activeName === 'first')) {
            this.$weblog.showLog('LOCALLIFE_MODULE', {
                identity_type: this.accountType,
                module_name: 'PHONE_CODE',
            });
        } else if (val === 'second' || (val === true && this.activeName === 'second')) {
            this.$weblog.showLog('LOCALLIFE_MODULE', {
                identity_type: this.accountType,
                module_name: 'SCAN_CODE',
            });
        }
    }

    itemShowLog(type: 'PHONE_CODE' | 'SCAN_CODE') {
        return {
            eventName: 'LOCALLIFE_MODULE',
            params: {
                identity_type: this.accountType,
                module_name: type,
            },
        };
    }
}
